// Shared color mappings for AsapProfile components.
// Extracted to avoid duplicating identical mappings across ProfileCard,
// AsapProfile (list cards) and CriteriaForm.

// Score → Chakra colorScheme used on profile/search-card score badges.
// Thresholds: >=80 green, >=60 teal, >=40 yellow, else orange. Null/undefined
// returns gray so the badge still renders meaningfully when no score exists.
export const scoreColorScheme = (score) => {
  if (score === null || score === undefined) return "gray";
  if (score >= 80) return "green";
  if (score >= 60) return "teal";
  if (score >= 40) return "yellow";
  return "orange";
};

// Required vs optional skill tier → chip colorScheme (matched-skills chips on
// candidate profile cards).
export const TIER_COLOR = {
  required: "red",
  optional: "blue",
};

// Skill type (technical / functional / business) → chip colorScheme used on
// criteria-form skills and on the search-card skill chips.
export const SKILL_TYPE_COLOR = {
  technical: "purple",
  functional: "orange",
  business: "green",
};

// Loading-batch → Chakra colorScheme. batch 1 (the initial search) is blue,
// each subsequent "Load 12 more" cycles to the next colour. Drives the
// coloured left border on candidate cards and the legend swatches so the user
// can tell at a glance which load surfaced a given profile. Cycles if a search
// somehow exceeds the palette length.
export const BATCH_COLOR_SCHEMES = [
  "blue",
  "orange",
  "purple",
  "pink",
  "cyan",
  "teal",
];

export const batchColorScheme = (batchIndex) => {
  const n =
    Number.isFinite(batchIndex) && batchIndex >= 1 ? Math.floor(batchIndex) : 1;
  return BATCH_COLOR_SCHEMES[(n - 1) % BATCH_COLOR_SCHEMES.length];
};
